// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './useAuth'
import { ROUTES } from '@/constants/routes'
import type { Permission } from '@/constants/permissions'
import { hasPermission } from './permissions'

interface ProtectedRouteProps {
  children: React.ReactNode
  permission?: Permission
  fallback?: React.ReactNode
}

export function ProtectedRoute({ children, permission, fallback }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth()
  const location = useLocation()

  if (isLoading) return null

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  if (permission && !hasPermission(user, permission)) {
    return fallback ? <>{fallback}</> : <Navigate to={ROUTES.DASHBOARD} replace />
  }

  return <>{children}</>
}
